/**
 *  routes/admin.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

import Home from "../views/Home/Home";
import Users from "../views/Users/Users";
import BurnedReport from "../views/BurnedReport/BurnedReport"
import DeforestationReport from "../views/DeforestationReport/DeforestationReport"
import Notifications from "../views/Notifications/Notifications";
import VirtualFence from "../views/VirtualFence/VirtualFence";
import Videos from "../views/Videos/Videos";
import DangerZone from "../views/DangerZone/DangerZone";
import Alerts from "../views/Alerts/Alerts";
import Follow from "../views/Follow/Follow"

const adminRoutes = [
    {
        path: "/home",
        name: "Monitoramento",
        icon: "pe-7s-map-2",
        component: Home
    },
    {
        path: "/users",
        name: "Usuários",
        icon: "pe-7s-users",
        component: Users
    },
    {
        path: "/virtual-fence",
        name: "Cerca Virtual",
        icon: "pe-7s-help2",
        component: VirtualFence
    },
    {
        path: "/danger-zone",
        name: "Área Sinistro",
        icon: "pe-7s-target",
        component: DangerZone
    },
    {
        path: "/alerts",
        name: "Avisos",
        icon: "pe-7s-attention",
        component: Alerts
    },
    {
        path: "/burned-reports",
        name: "Queimadas",
        icon: "pe-7s-sun",
        component: BurnedReport
    },
    {
        path: "/deforestation-reports",
        name: "Desmatamentos",
        icon: "pe-7s-leaf",
        component: DeforestationReport
    },
    {
        path: "/follow",
        name: "Acompanhar",
        icon: "pe-7s-hammer",
        component: Follow
    }/*,
    {
        path: "/notifications",
        name: "Enviar notificações",
        icon: "pe-7s-bell",
        component: Notifications
    },
    {
        path: "/videos",
        name: "Videos",
        icon: "pe-7s-video",
        component: Videos
    }*/
];

export default adminRoutes;



// WEBPACK FOOTER //
// ./src/routes/admin.jsx